import { combineReducers } from 'redux';

import TotalPos from './TotalPos';

export default combineReducers({
  TotalPos,
});
